// extracted by mini-css-extract-plugin
export var avatarContainer = "_4l-1";
export var largeAvatarContainer = "_4l-2";
export var smallAvatarContainer = "_4l-0";